import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text, Link } from 'reaxl';
import homeServicesConfig from '../homeServicesConfig';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const iconMap = {
  iconDelivery: homeServicesConfig.vehicleDelivery.iconSrcatc,
  iconVirtualTour: homeServicesConfig.virtualTour.iconSrcatc,
  iconTestDrive: homeServicesConfig.testDrive.iconSrcatc
};
function HomeServicesCTA(_ref) {
  let {
    data,
    icon,
    className,
    style,
    onClick,
    ...rest
  } = _ref;
  const {
    content,
    link
  } = data;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(className, 'display-flex align-items-center col-xs-12'),
    style: style,
    ...rest,
    children: [/*#__PURE__*/_jsx("img", {
      src: iconMap[icon],
      className: "col-xs-3 col-sm-4 col-md-3",
      style: {
        maxWidth: '150px'
      },
      alt: ""
    }), /*#__PURE__*/_jsxs(Text, {
      componentClass: "p",
      size: {
        xs: 400,
        sm: 600,
        lg: 700
      },
      weight: "bold",
      className: "ctaText margin-bottom-0",
      children: [content, /*#__PURE__*/_jsx(Link, {
        href: link.src,
        className: "ctaLink text-accent text-bold text-size-400 text-size-sm-600 text-size-lg-700",
        style: {
          marginLeft: '0.25em'
        },
        onClick: onClick,
        children: link.text
      })]
    })]
  });
}
export default HomeServicesCTA;